
import React, { Component } from 'react';
import {SideBar, SideBarHead, SideList, SideListItemGeneric} from 'app/components/SideBar/';
import HoneypotSetForm from './HoneypotSetForm';
import NewHoneypotSet from './models/HoneypotSetModel';
import HoneypotSetHome from './components/HoneypotSetHome/HoneypotSetHomeComponent';
import HoneypotSetService from "../../../services/honeypotSet.service";
import  GetErrorMessage  from 'app/helpers/error-message'
import {ShowError, ShowSuccess} from "app/components/toast"
import { Loading } from '@ecosystem/ui-lib/core/components/Loading';
import {BlockUi} from 'app/components/Basics/';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import Modal from 'app/components/Modal';
import './HoneypotSetComponent.scss';

class HoneypotSet extends Component {	
	constructor (props) {
	super(props);
		this.state = {
			search: '',			
			allData: [],
			filteredData: [],			
			loading: false,
			errorMessage: null,
			selectedHoneypotSet: null,
			originalSelectedHoneypotSet: null,
			uiBlocked: false,
			editorOpen: false			
		}
	}

	setSearchState(event) {    
		var value = event.target.value;    
		this.setState({search: value});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.search !== prevState.search) {     
			this.filterHoneypotSets(this.state.search);
		}

		if (this.state.editorOpen !== prevState.editorOpen) {
			if (this.state.editorOpen) {
			//retrigger selected question if editor was closed        
			this.setState({selectedHoneypotSet: this.state.selectedHoneypotSet});
			}
		}    
	}

	filterHoneypotSets(term) {		
		if (term !== '') {
			const filteredData = this.state.allData
			.filter(i => (i.name  && i.name.toLowerCase().includes(term.toLowerCase())));
			let newFilteredData = [...filteredData];
			this.setState({ filteredData: newFilteredData});      
		}
		else {
			let newFilteredData = [...this.state.allData];
			this.setState({ filteredData: newFilteredData});     
		}
	}

	componentDidMount() {		
		this.queryHoneypotSets('');		
	}

	openEditor() {
		this.setState({ editorOpen: true });
	}

	closeEditorButtonOnClick() {
		if (this.shouldLosePossibleChangesOnEditor(this.closeEditor)) {
			this.closeEditor();
		}
	}

	closeEditor() {
		this.setState({ editorOpen: false });
		this.setSelectedItem(null);
	}

	queryHoneypotSets(term) {
		this.setState({ loading: true, filteredData: [] });
		HoneypotSetService.find(term)
			.then(response =>{				
				this.setState({ filteredData: response.data,
					allData:  response.data,					
					loading: false				
				}, function() { this.filterHoneypotSets(this.state.search); });
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}

	getHoneypotSetById(id) {		
		this.toggleUiBlock(true)
		HoneypotSetService.getHoneypotSetById(id)
			.then(response => {				
				this.updateSelectedHoneypotSet(response.data);		
				this.updateSavedHoneypotSetOnList(response.data);					
				this.setState(
					{originalSelectedHoneypotSet: cloneDeep(response.data)}
				);
				this.toggleUiBlock(false)
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ errorMessage: errorMessage});    
				this.toggleUiBlock(false)        
			})
	}	

	getSelectedItem(honeypotSetid) {		
		this.setState({clickedHoneypotSetid: honeypotSetid});		
		this.openEditor();
		if (this.shouldLosePossibleChangesOnEditor(()=>this.getHoneypotSetById(honeypotSetid))) {			
			this.getHoneypotSetById(honeypotSetid)			
		}	
	}

	setSelectedItem(selectedHoneypotSet) {		
		this.updateSelectedHoneypotSet(selectedHoneypotSet);
	}	

	shouldLosePossibleChangesOnEditor(callbackAfterLoseChangesConfirmation) {		
		if (this.didSelectedHoneypotSetChange()) {
			this.showLoseChangeConfirmationModal(callbackAfterLoseChangesConfirmation);
			return false;	
		}
		else {	
			return true;
		}	
	}

	didSelectedHoneypotSetChange() {
		let selectedHoneypotSet = this.state.selectedHoneypotSet;
		if (!selectedHoneypotSet) return false;
		let questionsAreEquals = isEqual(selectedHoneypotSet, this.state.originalSelectedHoneypotSet);
		return !questionsAreEquals;
	  }

	showLoseChangeConfirmationModal(callbackAfterLoseChangesConfirmation) {
		this.setState({ 
			loseChangesModalText: `There are unsaved changes to the survey '${this.state.selectedHoneypotSet.name}'. Are you sure do you want to leave without saving?`,
			callbackAfterLoseChangesConfirmation: callbackAfterLoseChangesConfirmation
		});
	}

	confirmLoseChangesModalHandler() {
		let filteredData = this.rollbackToOriginalHoneypotSet(this.state.filteredData, this.state.originalSelectedHoneypotSet);
		let allData = this.rollbackToOriginalHoneypotSet(this.state.allData, this.state.originalSelectedHoneypotSet);	

		this.setState({allData: allData, filteredData: filteredData
		}, this.state.callbackAfterLoseChangesConfirmation);
		this.setState({clickedHoneypotSetid: null});
		this.hideLoseChangesModal();
	}

	rollbackToOriginalHoneypotSet(list, originalSelectedItem) {
		const index = list.findIndex(item => item.id === this.state.selectedHoneypotSet.id);	
		list[index] = originalSelectedItem;
		return list;
	}

	hideLoseChangesModal() {
		this.setState({loseChangesModalText: ''})
	}

	isItemSelected(honeypotSetId) {    
		if (this.state && this.state.selectedHoneypotSet && 
			this.state.selectedHoneypotSet.id === honeypotSetId) {
			return true;
		} else {
			return false;
		}
	}

	toggleUiBlock(blockUi) {
		this.setState ({uiBlocked: blockUi});
	} 

	addNewHoneypotSetHandler = event => {
		if (this.shouldLosePossibleChangesOnEditor(() => this.addNewHoneypotSet())) {
			this.addNewHoneypotSet()
		}    
		event.preventDefault();
	}

	addNewHoneypotSet() {		
		const newHoneypotSet = NewHoneypotSet();		
		this.setSelectedItem(null);
		this.setSelectedItem(newHoneypotSet);
		this.openEditor();
	}

	removeDeletedHoneypotSet(honeypotSetId) {    
		const newFilteredData = this.state.filteredData.filter(i => i.id !== honeypotSetId);
		const newAllData = this.state.allData.filter(i => i.id !== honeypotSetId);
		this.setState({ filteredData: newFilteredData,
			allData: newAllData
			});    
	}

	updateSavedHoneypotSetOnList(selectedHoneypotSet) {
		let newFilteredData = [...this.updateHoneypotSetList(this.state.filteredData, selectedHoneypotSet)];	
		let newAllData = [...this.updateHoneypotSetList(this.state.allData, selectedHoneypotSet)];
		this.setState({filteredData: []});
		this.setState({filteredData: newFilteredData, 
			allData: newAllData
		});
	}

	updateHoneypotSetList(list, selectedHoneypotSet) {		
		var index = list.findIndex(q => q.id === selectedHoneypotSet.id);
		if (index === -1) {
			list.push(selectedHoneypotSet);      
		}
		else {
			list[index] = selectedHoneypotSet;      
		}
		return list;
	}

	getListItems() {
		return this.state.filteredData.map(honeypotSet => 
			<div key={honeypotSet.id}>
				<SideListItemGeneric key={honeypotSet.id}
					id={honeypotSet.id}					
					getSelectedItem={this.getSelectedItem.bind(this)}				
					isItemSelected={this.isItemSelected(honeypotSet.id)}
					menuItemId={honeypotSet.id}
				>
					{honeypotSet.name}
				</SideListItemGeneric>
		</div>
		)
	}	

	updateSelectedHoneypotSet(selectedHoneypotSet) {		
		this.setState({selectedHoneypotSet: selectedHoneypotSet})
	}
	

    render() {
        return (
			<BlockUi tag="div" blocking={this.state.uiBlocked}>  
			<main className="app-body honeypotsets">                   
				<SideBar>
					<SideBarHead canChangeData={this.props.userPermissions?.CanChangeHoneypotQuestion} tagName="SideBarHead" headline="Honeypot Sets" fontSize="h2" addButton addButtonLabel="Set" addButtonCallBack={this.addNewHoneypotSetHandler.bind(this)}
						toolbar={(
						<div>							
						</div>  
					)} onChange={this.setSearchState.bind(this)}
					/>                  
					<SideList tagName="SideList">                  
						<Loading active={this.state.loading}></Loading>
						<div>
							{this.getListItems()}
						</div>
					</SideList>					
				</SideBar>

				<div className="app-content scrollbox">
					{this.state.editorOpen && ( <HoneypotSetForm openEditor={this.openEditor.bind(this)} 
							didSelectedHoneypotSetChange={this.didSelectedHoneypotSetChange.bind(this)}
							closeEditorButtonOnClick={this.closeEditorButtonOnClick.bind(this)} 
							closeEditor={this.closeEditor.bind(this)}
							removeDeletedHoneypotSet={this.removeDeletedHoneypotSet.bind(this)} 
							toggleUiBlock={this.toggleUiBlock.bind(this)} 
							selectedHoneypotSet={this.state.selectedHoneypotSet}
							updateSelectedHoneypotSet={this.updateSelectedHoneypotSet.bind(this)}
							updateSavedHoneypotSetOnList={this.updateSavedHoneypotSetOnList.bind(this)}							
							getHoneypotSetById={this.getHoneypotSetById.bind(this)}							
							canChangeData={this.props.userPermissions?.CanChangeHoneypotQuestion}
							/> )}
					{!this.state.editorOpen && ( <HoneypotSetHome />)}
				</div>
				{this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
				{this.state.loseChangesModalText && ( <Modal size="small" content={this.state.loseChangesModalText} confirmModalHandler={this.confirmLoseChangesModalHandler.bind(this)} cancelModalHandler={this.hideLoseChangesModal.bind(this)} />)}
			</main>
			</BlockUi>
        );
    }
}

export default HoneypotSet;